import { useEffect, useState } from 'react';

import { HelpIcon, OverlayTriggerTooltip } from '@utilities';
import { readFastTracks } from '@api/fast_tracks';

import Column from '../../layouts/Column';
import { HELP_CENTER_BASE_URL } from './utilities/constants';
import InteractiveTile from './components/InteractiveTile';
import ModalBuildFastTrack from './components/ModalBuildFastTrack';

import styles from './_index.module.scss';

const FastTracks = () => {
  const [fastTrackRoutes, setFastTrackRoutes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState({});

  useEffect(() => {
    const fetchFastTrackRoutes = async () => {
      try {
        const response = await readFastTracks();

        setFastTrackRoutes(response);
      } catch (error) {
        console.error(error);
      }
    };

    fetchFastTrackRoutes();
  }, []);

  const handleTileClick = (route) => {
    setSelectedRoute(route);
    setIsModalOpen(true);
  };

  return (
    <Column className={styles['fast-tracks']}>
      <div className={styles['fast-track-header']}>
        <div>
          <h2>Welcome to Narratives</h2>
          <p>Discover how to quickly create a data story to support your business objective.</p>
        </div>
        <OverlayTriggerTooltip aria-label="Help" content="Help">
          <a
            className={[styles['action-icon']]}
            href={HELP_CENTER_BASE_URL}
            rel="noreferrer"
            target="_blank"
          >
            <HelpIcon />
          </a>
        </OverlayTriggerTooltip>
      </div>
      <div className={styles['interactive-tiles']}>
        {fastTrackRoutes.map((route) => (
          <InteractiveTile key={route.id} onClick={handleTileClick} route={route} />
        ))}
      </div>
      <ModalBuildFastTrack
        isModalOpen={isModalOpen}
        route={selectedRoute}
        setIsModalOpen={setIsModalOpen}
      />
    </Column>
  );
};

export default FastTracks;
